<app-auth-card
  [loader]="activateAccountComponentLoader"
  [title]="'auth.activateAccount.title' | translate"
  [description]="'auth.activateAccount.description' | translate"
>
  <form [formGroup]="editForm" (ngSubmit)="onSubmit()" class="grid grid-cols-1 gap-4">
    <div>
      <label
        [appRequiredLabel]="editForm.controls.email"
        for="email"
        class="block text-surface-900 dark:text-surface-0 text-xl font-medium mb-2"
        >{{ 'auth.activateAccount.email' | translate }}</label
      >
      <input
        pInputText
        id="email"
        type="email"
        autocomplete="username"
        class="w-full"
        formControlName="email"
        [placeholder]="'auth.activateAccount.email' | translate"
      />
      <app-form-error [control]="editForm.controls.email" />
    </div>

    <div>
      <label
        [appRequiredLabel]="editForm.controls.password"
        for="password"
        class="block text-surface-900 dark:text-surface-0 text-xl font-medium mb-2"
        >{{ 'auth.forgotPassword.newPassword' | translate }}</label
      >
      <p-password
        inputId="password"
        formControlName="password"
        autocomplete="new-password"
        [placeholder]="'auth.forgotPassword.newPassword' | translate"
        [toggleMask]="true"
        [feedback]="false"
        [fluid]="true"
      />
      <app-form-error [control]="editForm.controls.password" />
    </div>

    <div>
      <label
        [appRequiredLabel]="editForm.controls.confirmPassword"
        for="confirmPassword"
        class="block text-surface-900 dark:text-surface-0 text-xl font-medium mb-2"
        >{{ 'auth.forgotPassword.confirmPassword' | translate }}</label
      >
      <p-password
        inputId="confirmPassword"
        formControlName="confirmPassword"
        autocomplete="new-password"
        [placeholder]="'auth.forgotPassword.confirmPassword' | translate"
        [toggleMask]="true"
        [feedback]="false"
        [fluid]="true"
      />
      <app-form-error [control]="editForm.controls.confirmPassword" />
    </div>

    <p-button
      type="submit"
      [label]="'auth.forgotPassword.save' | translate"
      icon="pi pi-check"
      size="large"
      styleClass="w-full"
    />
  </form>
</app-auth-card>
